module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fieldData[_vm.fieldName]),
      expression: "fieldData[fieldName]"
    }],
    staticClass: "form-control",
    style: (_vm.qaqcSelectStyling),
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.fieldData, _vm.fieldName, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "true",
      "disabled": ""
    },
    domProps: {
      "value": 0
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Replace")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Ignore")]), _vm._v(" "), (_vm.hasAppend) ? _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Append")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b380195a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteForm/QaqcFormFieldSelect.vue
// module id = 987
// module chunks = 1